import React from 'react';
import { Box, Typography, Container } from '@mui/material';

export default function TermsOfService() {
    return (
        <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: '#f8f9fa' }}>
            <Container maxWidth="md">
                <Box sx={{ bgcolor: 'white', borderRadius: 2, p: { xs: 3, md: 5 }, boxShadow: 1 }}>
                    <Typography variant="h3" fontWeight="bold" sx={{ mb: 3, color: '#1e293b' }}>
                        Terms of Service
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 4, color: '#64748b' }}>
                        Last updated: {new Date().toLocaleDateString('en-EU')}
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        1. Acceptance of Terms
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        By accessing and using MeetMyBot services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service. These Terms of Service apply to all users of the service, including without limitation users who are browsers, vendors, customers, merchants, and contributors of content.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        2. Use License
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        Permission is granted to temporarily access and use MeetMyBot services for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                        <br />
                        • modify or copy the materials
                        <br />
                        • use the materials for any commercial purpose or for any public display (commercial or non-commercial)
                        <br />
                        • attempt to decompile or reverse engineer any software contained on the website
                        <br />
                        • remove any copyright or other proprietary notations from the materials
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        3. Description of Service
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        MeetMyBot provides AI-powered digital clone services that enable businesses to create virtual representatives for customer interaction. Our services include:
                        <br />
                        • AI clone creation and customization
                        <br />
                        • Integration with Salesforce and other CRM systems
                        <br />
                        • 24/7 customer support capabilities
                        <br />
                        • Analytics and reporting features
                        <br />
                        • API access for custom implementations
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        4. User Accounts and Registration
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        To access certain features of our service, you may be required to create an account. You agree to:
                        <br />
                        • Provide accurate, current, and complete information during registration
                        <br />
                        • Maintain and update your account information
                        <br />
                        • Maintain the security of your password and accept responsibility for all activities under your account
                        <br />
                        • Notify us immediately of any unauthorized use of your account
                        <br />
                        We reserve the right to refuse service, terminate accounts, or cancel orders at our sole discretion.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        5. Acceptable Use Policy
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        You agree not to use the service:
                        <br />
                        • For any unlawful purpose or to solicit others to perform unlawful acts
                        <br />
                        • To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances
                        <br />
                        • To infringe upon or violate our intellectual property rights or the intellectual property rights of others
                        <br />
                        • To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate
                        <br />
                        • To submit false or misleading information
                        <br />
                        • To upload or transmit viruses or any other type of malicious code
                        <br />
                        • To spam, phish, pharm, pretext, spider, crawl, or scrape
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        6. Subscription Plans and Billing
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        Our services are offered under different subscription plans:
                        <br />
                        • <strong>Free Plan:</strong> Limited features with usage restrictions
                        <br />
                        • <strong>Professional Plan:</strong> Monthly subscription with advanced features
                        <br />
                        • <strong>Enterprise Plan:</strong> Custom pricing with dedicated support
                        <br />
                        <br />
                        Subscription fees are billed in advance on a monthly basis and are non-refundable. We reserve the right to change our subscription fees upon 30 days notice.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        7. Intellectual Property Rights
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        The service and its original content, features, and functionality are and will remain the exclusive property of MeetMyBot and its licensors. The service is protected by copyright, trademark, and other laws. Our trademarks and trade dress may not be used without our prior written consent.
                        <br />
                        <br />
                        You retain ownership of any content you provide to create your AI clone, but you grant us a license to use, modify, and display such content for the purpose of providing our services.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        8. Privacy and Data Protection
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use our service. By using our service, you agree to the collection and use of information in accordance with our Privacy Policy.
                        <br />
                        <br />
                        We comply with the General Data Protection Regulation (GDPR) and other applicable data protection laws. You have rights regarding your personal data, including the right to access, rectify, erase, and port your data.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        9. Service Availability and Modifications
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We strive to provide continuous service availability but do not guarantee uninterrupted access. We may:
                        <br />
                        • Modify or discontinue any part of the service with or without notice
                        <br />
                        • Impose limits on certain features or restrict access to parts of the service
                        <br />
                        • Perform scheduled maintenance that may temporarily affect service availability
                        <br />
                        <br />
                        We will provide reasonable notice for planned maintenance and service modifications when possible.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        10. Disclaimer of Warranties
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        The information on this website is provided on an "as is" basis. To the fullest extent permitted by law, this company:
                        <br />
                        • Excludes all representations and warranties relating to this website and its contents
                        <br />
                        • Does not warrant that the service will be uninterrupted, timely, secure, or error-free
                        <br />
                        • Makes no warranties about the accuracy or completeness of the content
                        <br />
                        • Disclaims all warranties, express or implied, including warranties of merchantability and fitness for a particular purpose
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        11. Limitation of Liability
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        In no event shall MeetMyBot, its directors, employees, partners, agents, suppliers, or affiliates be liable for:
                        <br />
                        • Any indirect, incidental, special, consequential, or punitive damages
                        <br />
                        • Any loss of profits, revenues, data, or use
                        <br />
                        • Any damages arising from your use or inability to use the service
                        <br />
                        • Any damages resulting from unauthorized access to your data
                        <br />
                        <br />
                        Our total liability shall not exceed the amount paid by you for the service in the 12 months preceding the claim.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        12. Indemnification
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        You agree to defend, indemnify, and hold harmless MeetMyBot and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees).
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        13. Termination
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We may terminate or suspend your account and bar access to the service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including but not limited to a breach of the Terms.
                        <br />
                        <br />
                        You may terminate your account at any time by contacting us. Upon termination, your right to use the service will cease immediately, and any data associated with your account may be deleted.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        14. Governing Law and Jurisdiction
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        These Terms shall be interpreted and governed by the laws of the European Union and the country where our registered office is located. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in that location.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        15. Dispute Resolution
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We are committed to resolving disputes amicably. Before pursuing legal action, you agree to:
                        <br />
                        • Contact us directly to attempt to resolve the issue
                        <br />
                        • Engage in good faith negotiations for at least 30 days
                        <br />
                        • Consider alternative dispute resolution methods such as mediation
                        <br />
                        <br />
                        EU consumers have the right to use the European Commission's Online Dispute Resolution platform.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        16. Force Majeure
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We shall not be liable for any failure to perform our obligations under these Terms if such failure is due to circumstances beyond our reasonable control, including but not limited to acts of God, natural disasters, war, terrorism, labor disputes, or government regulations.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        17. Severability
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect. The invalid provision will be replaced with a valid provision that most closely reflects the intent of the original provision.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        18. Changes to Terms
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We reserve the right to update these Terms of Service at any time. We will notify users of any material changes by:
                        <br />
                        • Posting the updated terms on our website
                        <br />
                        • Sending email notification to registered users
                        <br />
                        • Displaying a prominent notice on our website
                        <br />
                        <br />
                        Continued use of the service after changes constitutes acceptance of the updated terms.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        19. Contact Information
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        If you have any questions about these Terms of Service, please contact us:
                        <br />
                        Email: contact@eternity.ac
                        <br />
                        Subject line: "Terms of Service Inquiry"
                        <br />
                        <br />
                        We will respond to your inquiry within 5 business days.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        20. Entire Agreement
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        These Terms of Service, together with our Privacy Policy and Cookie Policy, constitute the entire agreement between you and MeetMyBot regarding the use of our service. These Terms supersede all prior and contemporaneous understandings, agreements, representations, and warranties.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}